module.exports = __webpack_public_path__ + "static/media/2.efd3a845.jpg";